<app-organizer-shared-layout-dashboard
  class="organizer-payout-invoices"
  [fullWidth]="true"
  [hasFooter]="true"
>
  <app-section [title]="'organizer_payout_invoices.title' | translate">
    <aside *ngIf="!isLoading && !hasApiError" class="flex justify-start pr-4">
      <form
        [formGroup]="formGroup"
        class="flex flex-col md:flex-row justify-between md:items-center w-full"
      >
        <app-form-input-group
          class="mb-3"
          [label]="'organizer_payout_invoices.search.label' | translate"
        >
          <app-form-input
            formControlName="name"
            type="search"
            autocomplete="off"
            [placeholder]="placeholderInput"
            class="w-full"
          ></app-form-input>
        </app-form-input-group>
        <button
          app-vtmn-play-button
          type="button"
          [type]="ctaButtonType.Button"
          [variant]="vtmnPlayButtonVariant.PRIMARY"
          (click)="tableExport()"
          [disabled]="payoutInvoices?.length === 0"
        >
          {{ 'organizer_payout_invoices.button.export' | translate }}
        </button>
      </form>
    </aside>
    <table
      *ngIf="!isLoading && !hasApiError && payoutInvoices?.length > 0"
      class="organizer-payout-invoices__table mt-4"
    >
      <caption class="organizer-payout-invoices__table__caption">
        {{
          'organizer_payout_invoices.array.title' | translate
        }}
      </caption>
      <thead class="organizer-payout-invoices__table__thead">
        <tr class="organizer-payout-invoices__table__thead__tr">
          <th scope="col">
            <button type="button" (click)="sortInvoices('createdAt', 'date')">
              {{ 'organizer_payout_invoices.array.payout_date' | translate }}
            </button>
            <vtmn-play-icon
              class="organizer-payout-invoices__icon ml-1 cursor-pointer"
              [name]="iconTypeEnum.ArrowUpDown"
              aria-hidden="true"
              (click)="sortInvoices('createdAt', 'date')"
            ></vtmn-play-icon>
          </th>
          <th scope="col">
            <button type="button" (click)="sortInvoices('invoiceNumber')">
              {{ 'organizer_payout_invoices.array.invoice_id' | translate }}
            </button>
            <vtmn-play-icon
              class="organizer-payout-invoices__icon ml-1 cursor-pointer"
              [name]="iconTypeEnum.ArrowUpDown"
              aria-hidden="true"
              (click)="sortInvoices('invoiceNumber')"
            ></vtmn-play-icon>
          </th>
          <th scope="col">
            {{ 'organizer_payout_invoices.array.amount' | translate }}
          </th>
          <th scope="col">
            {{
              'organizer_payout_invoices.array.commission_amount' | translate
            }}
          </th>
          <th scope="col">
            {{ 'organizer_payout_invoices.array.activity_date' | translate }}
          </th>
          <th scope="col">
            <button type="button" (click)="sortInvoices('activity', 'name')">
              {{ 'organizer_payout_invoices.array.activity_name' | translate }}
            </button>
            <vtmn-play-icon
              class="organizer-payout-invoices__icon ml-1 cursor-pointer"
              [name]="iconTypeEnum.ArrowUpDown"
              aria-hidden="true"
              (click)="sortInvoices('activity', 'name')"
            ></vtmn-play-icon>
          </th>
          <th scope="col">
            {{ 'organizer_payout_invoices.array.export' | translate }}
          </th>
        </tr>
      </thead>
      <tbody
        *ngIf="payoutInvoices?.length > 0"
        class="organizer-payout-invoices__table__tbody"
      >
        <ng-container *ngFor="let invoice of payoutInvoices">
          <tr
            class="organizer-payout-invoices__table__tbody__tr even:bg-background-tertiary"
          >
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.payout_date' | translate
              "
            >
              {{ invoice.createdAt?.date | localizedDate: 'dd/MM/y' }}
            </td>
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.invoice_id' | translate
              "
            >
              {{ invoice.invoiceNumber }}
            </td>
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.amount' | translate
              "
            >
              {{
                invoice.amount?.amount | displayPrice: invoice.amount?.currency
              }}
            </td>
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.commission_amount' | translate
              "
            >
              {{ invoice.feeAmount | displayPrice: invoice.amount?.currency }}
            </td>
            <!-- Add localizedDate pipe when back has fixed date format sent by API -->
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.activity_date' | translate
              "
            >
              {{ invoice.activity?.date }}
            </td>
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.activity_name' | translate
              "
              class="organizer-payout-invoices__table__tbody__tr__name"
            >
              <span
                class="organizer-payout-invoices__table__tbody__tr__name--mobile"
              >
                {{ invoice.activity?.name }}
              </span>
            </td>
            <td
              [attr.data-label]="
                'organizer_payout_invoices.array.export' | translate
              "
            >
              <span class="organizer-payout-invoices__table__tbody__tr__links">
                <a
                  [href]="invoice.attendeesUrl"
                  target="_blank"
                  class="organizer-payout-invoices__table__tbody__tr__links__item"
                >
                  {{
                    'organizer_payout_invoices.array.download.attendee'
                      | translate
                  }}
                </a>
                <a
                  [href]="invoice.feesUrl"
                  target="_blank"
                  class="organizer-payout-invoices__table__tbody__tr__links__item"
                >
                  {{
                    'organizer_payout_invoices.array.download.fee' | translate
                  }}
                </a>
              </span>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="payoutInvoices?.length === 0">
          <td colspan="7">
            <app-tips
              class="block mt-4"
              [icon]="iconTypeEnum.Information"
              [variant]="tipsVariant.INFO"
              [title]="
                'organizer_payout_invoices.search.tips.title' | translate
              "
              [tips]="
                'organizer_payout_invoices.search.tips.description' | translate
              "
            >
            </app-tips>
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination-buttons
      *ngIf="!isLoading && !hasApiError && hasPagination"
      [hasLoadMoreButton]="hasLoadMoreButton"
      (loadMore)="getMoreInvoices()"
      class="block mt-6"
    >
    </app-pagination-buttons>

    <ng-container
      *ngIf="!isLoading && !hasApiError && payoutInvoices?.length === 0"
    >
      <app-tips
        class="block mt-4"
        [icon]="iconTypeEnum.Information"
        [variant]="tipsVariant.WARNING"
        [title]="'organizer_payout_invoices.no_invoices.title' | translate"
        [tips]="'organizer_payout_invoices.no_invoices.description' | translate"
      >
      </app-tips>
    </ng-container>

    <ng-container *ngIf="!isLoading && hasApiError">
      <app-tips
        class="block mt-4"
        [icon]="iconTypeEnum.Information"
        [variant]="tipsVariant.DANGER"
        [title]="'organizer_payout_invoices.api_error.title' | translate"
        [tips]="'organizer_payout_invoices.api_error.description' | translate"
        [displayArrowIcon]="false"
      >
      </app-tips>
    </ng-container>

    <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
  </app-section>
</app-organizer-shared-layout-dashboard>
